import { mapGetters, mapActions } from 'vuex';
import axios from "axios";

export default {
  computed: {
    ...mapGetters(["langByLanguage"]),
  },
  data () {
    return {
      timer: {}
    }
  },
  methods: {
    ...mapActions(["setLangByLanguage"]),
    goLang(key) {
      const hasAnyLang = Object.keys(this.langByLanguage).length > 0;

      key = key.trim();
      if(!key) {
        return;
      }
      const found = this.langByLanguage[key];
      if (found) return found;

      if (hasAnyLang) {
        let data = {
          key_word: key,
        };
        axios.post("print/auto-tran", data).then(() => {
          console.log('Dịch đi');
          clearTimeout(this.timer)
          let _this = this
          this.timer = setTimeout(function () {
            _this.fetchUserLogin();
          }, 3000)
        });
      }

      return key;
    },
    fetchUserLogin() {
      console.log('xxxxxxx');
      axios.get("auth/user-login").then((response) => {
        this.loading = false
        switch (response.data.code) {
          case 200:
            this.setLangByLanguage(response.data.data.langByLanguage);
            break;
          default:
            break;
        }
      }).catch( errors => {
        console.log(errors);
      });
    },
  }
}
